'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { useAppContext } from '@/app/_lib/_context';
import { useCustomer } from '@/app/_lib/hooks/useCustomer';
import PromoSideTab from './PromoSideTab';
import SaleSideTab from './SaleSideTab';

// Routes where side tabs should be hidden
const HIDDEN_TAB_ROUTES = ['/checkout', '/order', '/newsletter-sign-up'];
const SideTabs = () => {
  const $ = _c(2);
  const {
    sideTabToShow,
    mobileMenuOpen
  } = useAppContext();
  const {
    customer,
    isLoading: customerLoading
  } = useCustomer();
  const isTradeCustomer = customer?.trade_account === 1;
  const pathname = usePathname();
  if (customerLoading) {
    return null;
  }
  if (mobileMenuOpen) {
    return null;
  }
  if (HIDDEN_TAB_ROUTES.some(route => pathname?.startsWith(route))) {
    return null;
  }
  if (sideTabToShow === "sale" && pathname?.includes("category555")) {
    return null;
  }
  if (sideTabToShow === "promo" && isTradeCustomer) {
    return null;
  }
  if (sideTabToShow === "promo") {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <PromoSideTab />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (sideTabToShow === "sale") {
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <SaleSideTab />;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  return null;
};
export default SideTabs;